import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";

const instructionApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/testdetails";

const examQuestionApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_single_question";

const examAllQuestionApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/allquestionlist";

const saveAnswerApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_single_save";

const practiceApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/user/practicelist";

const submitExamApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/exam_submit";

const bookmarkApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/saveBookmark";

const pyqYearWise =
  "https://learning.motion.ac.in/motioneducation/api/v1/pyqyearlist";

const pyqYearwisePaperApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/pyq_yearwise_paper";

const pyqTopicWisePaperApi =
  "https://learning.motion.ac.in/motioneducation/api/user/UserSubjectOTS";

const pyqSubjectWiseApi =
  "https://learning.motion.ac.in/motioneducation/api/user/pyqSubjectWiseTopics";

const pyqTopicWiseSetApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/getTopicWisePracticeSets";

const subjectListApi =
  "https://learning.motion.ac.in/motioneducation/api/v1/subjectlist";

const examApi = {
  getPyqYearWise: async ({ topic, format }) => {
    const res = await axioInstance.get(`${pyqYearWise}?topic=${topic}`);
    return res.data;
  },

  getPyqYearwisePapers: async ({ year, target }) => {
    const res = await axioInstance.get(
      `${pyqYearwisePaperApi}?year=${year}&target=${target}`
    );
    return res.data;
  },
  getInstruction: async ({ paperType, paperId, plannerId, testId, setId }) => {
    const res = await axioInstance.get(
      `${instructionApi}?paper_type=${paperType}&test_id=${testId}&planner_id=${plannerId}&paper_id=${paperId}&set_id=${setId}`
    );
    return res.data;
  },

  getQuestion: async ({ paperType, paperId, qid, testId, setId ,plannerTestId }) => {
    const res = await axioInstance.get(
      `${examQuestionApi}?paper_type=${paperType}&paper_id=${paperId}&qid=${qid}&test_id=${testId}&set_id=${setId}&planner_test_id=${plannerTestId}`
    );
    return res.data;
  },

  getQuestionList: async ({ paperType, paperId, testId, setId }) => {
    const res = await axioInstance.get(
      `${examAllQuestionApi}?paper_type=${paperType}&paper_id=${paperId}&test_id=${testId}&set_id=${setId}`
    );
    return res;
  },

  getPracticeList: async () => {
    const res = await axioInstance.get(practiceApi);
    return res;
  },

  saveAnswer: async (payload) => {
    const res = await axioInstance.post(saveAnswerApi, payload);
    return res.data;
  },

  submitExam: async ({ paperType, paperId, testId,setId,time }) => {
    const res = await axioInstance.post(
      `${submitExamApi}?paper_type=${paperType}&paper_id=${paperId}&set_id=${setId}&test_id=${testId}&time=${time}`
    );
    return res.data;
  },

  saveBookmark: async ({ type, status, reference_id }) => {
    const res = await axioInstance.post(
      `${bookmarkApi}?type=${type}&status=${status}&reference_id=${reference_id}`
    );
    return res.data;
  },
  subjectList: async ({ paperType }) => {
    const res = await axioInstance.get(
      `${subjectListApi}?paper_type=${paperType}`
    );
    return res.data;
  },
  topicWise: async ({ course_id, class_id }) => {
    const res = await axioInstance.post(
      `${pyqTopicWisePaperApi}?course_id=${course_id}&class_id=${class_id}`
    );
    return res.data;
  },
  subjectWise: async ({ subject }) => {
    const res = await axioInstance.post(
      `${pyqSubjectWiseApi}?subject=${subject}`
    );
    return res.data;
  },
  subjectWiseSet: async ({ subject, topic, format }) => {
    const res = await axioInstance.post(
      `${pyqTopicWiseSetApi}?subject=${subject}&topic=${topic}&format=${format}`
    );
    return res.data;
  },
  getPyqTopicWiseSets: async ({ subject, topic }) => {
    const res = await axioInstance.post(
      `${pyqTopicWiseSetApi}?subject=${subject}&topic=${topic}`
    );
    return res.data;
  },
};

export default examApi;
